var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToCheckout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 643 453.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".o{fill:#fff;}.p{clip-path:url(#l);}.q{fill:#908d8b;}.r{fill:#9e9c9a;}.s{fill:#59b4ae;}.t{opacity:.6;}.u{fill:#80b2ff;}.v{fill:#2c2823;}.w{fill:url(#i);opacity:.58;}.w,.x,.y{isolation:isolate;}.a`{fill:#dbdad9;}.x{opacity:.3;}.aa{fill:#ff9f34;}.ab{fill:#347175;}.ac{fill:#0046b3;}.ad{clip-path:url(#n);}.ae{fill:#efeded;}.af{fill:#7c7875;}.ag{fill:#b2b0ae;}.ah{fill:#47433f;}.ai{fill:#d1f5ff;}.aj{fill:url(#g);}.ak{clip-path:url(#m);}.al{fill:#498183;}.am{fill:url(#h);}.y{fill:url(#j);opacity:.54;}.an{fill:url(#d);}.ao{fill:#4d93ff;}.ap{fill:#d9ffff;}.aq{fill:#868380;}.ar{fill:#cbcbca;}.as{fill:#66a2ff;}.at{fill:#64615d;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 689.38,
    y1: 64.23,
    x2: 19.26,
    y2: 405.85,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#f5f9f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#e4f0ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#d8e9e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#d1e6e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#d0e5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#bdd6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#abcbc5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 443.51,
    y1: 2131.92,
    x2: 344.69,
    y2: 2079.95,
    gradientTransform: "translate(0 2488) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#eee",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#e5e6e4",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#dfdfde",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d8d8d7",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#d3d4d2",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#cfcfce",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#cdcccb",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#cbcbca",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cacac9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 1956.94,
    y1: 2131.92,
    x2: 1858.13,
    y2: 2079.95,
    gradientTransform: "translate(2208.37 2488) rotate(-180)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 346.89,
    cy: 1944.13,
    fx: 346.89,
    fy: 1944.13,
    r: 123.42,
    gradientTransform: "translate(0 2834.4) scale(1 -1.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fff",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9f9f9",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f4f5f5",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f0efee",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#e8e8e6",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#e0e0df",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#d6d6d5",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbcbca",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cacac9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 347.01,
    cy: 2534.64,
    fx: 347.01,
    fy: 2534.64,
    r: 84.43,
    gradientTransform: "translate(0 2333.51) scale(1 -.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f4f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#e8e8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#d6d6d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#cacac9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M360.15,150.35c-.41-3.54-.61-7.2-.51-10.94,.08-2.9,.34-5.83,.82-8.76-4.09-.15-8.33-.24-12.68-.24s-9,.09-13.27,.26c.47,2.93,.74,5.85,.81,8.74,.1,3.72-.11,7.38-.52,10.91-2.17,18.89-10.19,33.97-10.19,33.97l22.86,9.7,22.86-9.67s-8.02-15.08-10.19-33.98Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M243.56,115.39c0-56.35,67.71-103.06,104.07-104.31,31.33-1.08,102.77,46.27,102.77,102.62"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "ag",
    points: "359.66 105.62 334.34 105.62 334.34 9.29 346.77 0 359.66 9.29 359.66 105.62"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "M459.18,434.14c-11.07-6.42-28.02-8.32-47.81-8.01-18.55,.31-43.89,4.45-62.39,4.83-22.07,.45-37.56-3.25-59.62-2.79-6.37,.14-11.62-1.85-18.01-1.39-9.84,.32-19.12,1.83-26.06,5.29-5.8,2.9-9.88,6.61-3.19,11.47,6.69,4.86,17.35,6.06,30.87,6.81,18.34,1.08,37.54,.44,55.78,0,19.53-.45,38.24,1.84,57.7,2.83,8.73,.44,17.82,.43,26.68,.53h10.28c9.76-.07,11.44-.53,21.32-1.34,17.47-1.34,26.29-11.35,14.45-18.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M538.49,374s-55.66,25.88-111.14,34.86c-7.72,1.25-14.88,3.38-21.47,6.14-26.98-4.07-58.21-5.97-93.82-1.78-42.18,4.97-74.32,7.63-99.6,7.13-26.42-.51-65.13-2.76-81.06-32-7.51-13.77-7.42-31.11-8.37-47.41-2.74-47.26-36.59-54.39-58.88-87.17-9.46-13.92-16.25-30.98-16.14-48.75,.2-32.21,28.16-53.66,46.61-73.42,16.11-17.24,35.7-36.15,58.32-42.07,25.99-6.8,48.86,6.66,73.34,13.08,18.88,4.96,39.57,7.34,59.01,7.79,47.2,1.07,92.77-14.02,135.22-35.44,25.33-12.78,48.89-27.12,70.05-39.23,60.52-34.63,101.57-51,109.44,39.38,10.02,115.11,122.1,286.48-61.52,298.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M488.62,261.89c-2.47-5.42-6.43-10.07-10.54-14.32-1-1.01-2.07-1.95-3.19-2.83l-.1-.11-.38-.29,.2,.15c-.07-.09-.15-.18-.23-.25-.14-.13-.29-.25-.45-.36-.34-.31-.69-.62-1.03-.93-.16-.15-.34-.29-.52-.42-.13-.18-.28-.33-.46-.45l-.14-.1c-.14-.13-.3-.25-.46-.36-.16-.1-.33-.17-.49-.27-.46-.3-.91-.62-1.38-.9s-.74-.59-1.13-.86c-.74-.47-1.39-1.04-2.12-1.48-.3-.15-.6-.32-.88-.5-.39-.3-.81-.56-1.25-.78-.25-.13-.53-.3-.81-.46-.79-.63-1.85-1.45-2.66-2-.45-.22-.87-.49-1.26-.79-1.06-.91-5.31-3.76-8.84-6.11-.42-.39-.83-.74-1.26-1.14s-1.09-.81-1.62-1.22c-.56-.4-1.05-.88-1.48-1.42-.43-.57-.9-1.12-1.39-1.64-.15-.15-.45-.42-.5-.48s-.49-.74-.27-.35c-.52-.93-1.02-1.92-1.6-2.86,.17,1.1,.33,2.23,.39,3.27,.2,3.38,.24,6.77,.17,10.15-.13,6.74-.31,13.49-.33,20.23l.52,.41,.5,.42c1.93,1.59,3.96,3.06,6.08,4.4,.92,.59,1.88,1.11,2.86,1.62s1.83,1.09,2.75,1.65c.91,.56,1.8,1.37,2.7,2.03,.7,.67,1.37,1.38,2.1,1.98,.38,.37,.78,.73,1.19,1.05,.1,.08,.19,.17,.27,.26,.44,.59,.88,1.19,1.42,1.81,.07,.07,.13,.14,.19,.21s.19,.27,.27,.41c.33,.52,.68,1.04,1.04,1.56,.36,.71,.65,1.46,.85,2.23,.34,1.25,.74,2.6,.45,3.88-.05,.15-.08,.31-.1,.47l-.15,.39c-.1,.31-.16,.55-.27,.86-.19,.47-.33,.94-.54,1.4-.49,.95-1.21,1.76-2.1,2.35-.61,.41-1.21,.82-1.8,1.25l-1.57,.47c-1.48,.47-2.97,.86-4.5,1.25l-.62,.13-1.11,.14c-1.56,.17-3.13,.24-4.7,.21-.37,0-2.53-.24-2.5-.21-3.02-.55-6.02-1.25-8.97-2.11-14.54-3.88-29.72-7.76-44.86-5.52-6.36,.94-10.39,9.3-8.56,15.06,2.23,6.94,8.25,9.56,15.06,8.55-1.87,.28,2.07,.19,2.59,.21,1.68,.05,3.37,.13,5.05,.26,3.17,.19,6.32,.63,9.42,1.31,6.33,1.3,12.5,3.26,18.77,4.8,6.91,1.79,14.09,2.37,21.2,1.73,6.8-.68,14.99-2.78,20.94-6.2,6.73-3.76,11.87-9.83,14.48-17.09,2.75-7.72,.98-16.54-2.32-23.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M460.06,234l.5,.33c-.16-.12-.33-.23-.5-.33Zm-247.66,27.02c4.18-15.96,18.51-25.5,30.91-35.35,3.2-2.46,6.2-5.16,9-8.07,.18-.19,.59-.65,.94-1.07l.44-.56-.39,33.53c-2.86,2.23-5.67,4.45-8.3,6.89-1.02,.93-2.01,1.9-2.97,2.9-.32,.34-.63,.69-.94,1.04-1.19,1.58-2.25,3.26-3.19,5-.32,.85-.6,1.72-.83,2.6l.44,.24c1.07,.35,2.16,.64,3.27,.86,6.26,.56,12.55-.12,18.82,.49,9.11,.89,17.2,3.71,23.83,10.03,4.68,4.45,8,10.11,11.5,15.43,.74,1.14,1.52,2.23,2.31,3.35,.31,.36,.62,.74,.95,1.08,.67,.71,1.39,1.39,2.13,2.03,.21,.16,.42,.31,.65,.45,.36,.22,.74,.41,1.09,.6,1.29,.43,2.61,.77,3.94,1.03,3.13,.29,6.27,.31,9.42,.3,6.72,0,13.07,5.94,12.69,12.52-.34,6.9-6.07,12.29-12.98,12.21-7.09,0-14.59-.13-21.27-2.67-7.15-2.72-12.52-7.09-17.07-12.93-3.23-4.12-5.82-8.61-8.84-12.87l-.33-.53c-.05-.05-.1-.11-.15-.17-.74-.89-1.53-1.74-2.37-2.55-.24-.23-.5-.45-.74-.68-.62-.37-1.24-.74-1.87-1.06-1.07-.34-2.16-.62-3.26-.84-9.17-.88-18.44,.58-27.45-1.89-6.72-1.84-12.67-5.62-16.64-11.18-4.24-5.89-4.5-13.44-2.74-20.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M313.27,337.5c-7.7,7.56-1.59,14.25-1.54,41.62,0,7.55-.33,15.08,.13,20.95,.62,7.87,1.86,10.91,0,12.7-2.06,1.98-5.56,.16-15.06-1.88-11.49-2.46-16.75-1.48-19.93,1.94-2.72,2.91-4.04,8.76-3.43,11.46,1.77,7.84,9.77,11,11.01,11.29,5.29,1.23,8.08,1.71,15.64,2.11,8.61,.47,9.07-1.19,15.53,0,5.3,.99,7.17,2.34,11.76,2.35,7.88,0,9.96-4.87,11.23-8.16,1.78-4.63-2.09-12.12-3.65-19.44-1.27-6.33-2.18-12.72-2.75-19.14-.74-7.16-.31-8.49-.13-17.7,.19-9.92,.74-14.53,.47-24.49-.32-12.73-1.42-15.12-3.29-16.46-3.84-2.73-11.56-1.54-15.99,2.83Zm68.3,0c7.69,7.56,1.59,14.25,1.54,41.62,0,7.55,.33,15.08-.13,20.95-.61,7.87-1.85,10.91,0,12.7,2.06,1.98,5.56,.16,15.06-1.88,11.49-2.46,16.75-1.48,19.94,1.94,2.72,2.91,4.04,8.76,3.43,11.46-1.77,7.84-9.77,11-11.01,11.29-5.3,1.23-8.08,1.71-15.64,2.11-8.61,.47-9.07-1.19-15.53,0-5.3,.99-7.17,2.34-11.76,2.35-7.88,0-9.96-4.87-11.23-8.16-1.78-4.63,2.09-12.12,3.66-19.44,1.27-6.32,2.18-12.72,2.74-19.14,.74-7.16,.32-8.49,.13-17.7-.19-9.92-.74-14.53-.47-24.49,.31-12.73,1.42-15.12,3.29-16.46,3.84-2.73,11.55-1.54,15.99,2.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M381.67,337.5c7.69,7.56,1.59,14.25,1.54,41.62,0,7.55,.33,15.08-.13,20.95-.61,7.87-1.85,10.91,0,12.7,2.06,1.98,5.56,.16,15.06-1.88,11.49-2.46,16.75-1.48,19.94,1.94,2.72,2.91,4.04,8.76,3.43,11.46-1.77,7.84-9.78,11-11.02,11.29-5.29,1.23-8.08,1.71-15.64,2.11-8.61,.47-9.07-1.19-15.52,0-5.31,.99-7.17,2.34-11.76,2.35-7.88,0-9.96-4.87-11.23-8.16-1.78-4.63,2.09-12.12,3.66-19.44,1.27-6.33,2.18-12.72,2.74-19.14,.74-7.16,.32-8.49,.13-17.7-.2-9.92-.74-14.53-.47-24.49,.31-12.73,1.41-15.12,3.29-16.46,3.84-2.73,11.56-1.54,16,2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M313.27,337.5c-7.7,7.56-1.59,14.25-1.54,41.62,0,7.55-.33,15.08,.13,20.95,.62,7.87,1.86,10.91,0,12.7-2.06,1.98-5.56,.16-15.06-1.88-11.49-2.46-16.75-1.48-19.93,1.94-2.72,2.91-4.04,8.76-3.43,11.46,1.77,7.84,9.77,11,11.01,11.29,5.29,1.23,8.08,1.71,15.64,2.11,8.61,.47,9.07-1.19,15.53,0,5.3,.99,7.17,2.34,11.76,2.35,7.88,0,9.96-4.87,11.23-8.16,1.78-4.63-2.09-12.12-3.65-19.44-1.27-6.33-2.18-12.72-2.75-19.14-.74-7.16-.31-8.49-.13-17.7,.19-9.92,.74-14.53,.47-24.49-.32-12.73-1.42-15.12-3.29-16.46-3.84-2.73-11.56-1.54-15.99,2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M443.03,139.79c-1.39-40.94-43.88-73.79-96.14-73.79s-94.75,32.86-96.14,73.79h-.07v149.14c.41,37.84,34.77,68.37,77.12,68.37h38.14c42.35,0,76.71-30.55,77.12-68.37V139.79h-.02Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "x",
    transform: "translate(265.23 117.79) scale(.74)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M418.28,150.31c0-13.6-14.84-24.63-33.21-24.63h-78.14c-18.34,0-33.21,11.03-33.21,24.63v44.1c-.14,1.06-.22,2.12-.23,3.18,0,23.13,32.42,41.88,72.4,41.88s72.4-18.75,72.4-41.88c0-.61,0-1.21-.07-1.81s.07-1.08,.07-1.62v-43.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M418.28,150.31c0-13.6-14.84-24.63-33.21-24.63h-78.14c-18.34,0-33.21,11.03-33.21,24.63v44.1c-.14,1.06-.22,2.12-.23,3.18,0,23.13,32.42,41.88,72.4,41.88s72.4-18.75,72.4-41.88c0-.61,0-1.21-.07-1.81s.07-1.08,.07-1.62v-43.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M443.09,252.34v-112.55h-.07c-1.39-40.94-43.88-73.79-96.14-73.79s-94.75,32.86-96.14,73.79h-.07v149.14c.41,37.84,34.77,68.37,77.12,68.37h38.14c42.35,0,76.71-30.55,77.12-68.37v-36.52m0,0v-.07m-24.81-58.17c0,.54,0,1.08-.07,1.62s.07,1.2,.07,1.81c0,23.13-32.41,41.88-72.4,41.88s-72.4-18.75-72.4-41.88c0-1.06,.09-2.13,.23-3.18v-44.1c0-13.6,14.84-24.63,33.21-24.63h78.2c18.34,0,33.21,11.03,33.21,24.63l-.04,43.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M418.28,150.31c0-13.6-14.84-24.63-33.21-24.63h-78.14c-18.34,0-33.21,11.03-33.21,24.63v44.1c-.14,1.06-.22,2.12-.23,3.18,0,23.13,32.42,41.88,72.4,41.88s72.4-18.75,72.4-41.88c0-.61,0-1.21-.07-1.81s.07-1.08,.07-1.62v-43.85Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "ab",
    cx: 312.75,
    cy: 168.26,
    rx: 6.77,
    ry: 11.91
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "ab",
    cx: 385.07,
    cy: 168.26,
    rx: 6.77,
    ry: 11.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M343.16,200.91h11.47c1.25,0,2.26,1.02,2.26,2.27,0,.31-.06,.62-.19,.9l-6.42,14.63c-.31,.76-1.18,1.12-1.94,.81-.37-.15-.66-.44-.81-.81l-6.43-14.66c-.5-1.12,0-2.44,1.12-2.94,.29-.13,.61-.2,.93-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M453.67,298.29c-1.21-4.54-2.68-8.97-3.71-13.5h-1.62c-.37,0-2.53-.24-2.5-.21-3.02-.55-6.02-1.25-8.97-2.11-14.54-3.88-29.72-7.76-44.86-5.52-6.36,.94-10.39,9.3-8.56,15.06,2.23,6.94,8.25,9.56,15.06,8.55-1.87,.28,2.07,.19,2.59,.21,1.68,.05,3.37,.13,5.05,.26,3.17,.19,6.32,.63,9.42,1.31,6.33,1.3,12.5,3.26,18.77,4.8,6.91,1.79,14.09,2.37,21.2,1.73-.39-3.56-1.02-7.1-1.88-10.58h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "as",
    x: 0,
    y: 212.46,
    width: 159,
    height: 95.09,
    rx: 5.63,
    ry: 5.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 0,
    y: 230.41,
    width: 159,
    height: 16.41,
    transform: "translate(159 477.24) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M122.58,289.3h23.38c1.49,0,2.69,1.2,2.69,2.69h0c0,1.49-1.2,2.69-2.69,2.69h-23.38c-1.49,0-2.69-1.2-2.69-2.69h0c0-1.49,1.2-2.69,2.69-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M86.63,289.3h23.38c1.49,0,2.69,1.2,2.69,2.69h0c0,1.49-1.2,2.69-2.69,2.69h-23.38c-1.49,0-2.69-1.2-2.69-2.69h0c0-1.49,1.2-2.69,2.69-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M50.68,289.3h23.38c1.49,0,2.69,1.2,2.69,2.69h0c0,1.49-1.2,2.69-2.69,2.69h-23.38c-1.49,0-2.69-1.2-2.69-2.69h0c0-1.49,1.2-2.69,2.69-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M14.73,289.3h23.38c1.49,0,2.69,1.2,2.69,2.69h0c0,1.49-1.2,2.69-2.69,2.69H14.73c-1.49,0-2.69-1.2-2.69-2.69h0c0-1.49,1.2-2.69,2.69-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M147.04,217.28h0c1.64,0,2.97,1.33,2.97,2.97v1.04c0,1.64-1.33,2.97-2.97,2.97h0c-1.64,0-2.97-1.33-2.97-2.97v-1.04c0-1.64,1.33-2.97,2.97-2.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M140.64,220.77h0c0,1.93-1.56,3.49-3.49,3.49h-12.37c-1.93,0-3.49-1.56-3.49-3.49h0c0-1.93,1.56-3.49,3.49-3.49h12.37c1.93,0,3.49,1.56,3.49,3.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "aa",
    x: 121.64,
    y: 255.65,
    width: 25.26,
    height: 23.06,
    rx: 6.89,
    ry: 6.89,
    transform: "translate(268.54 534.35) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M544.32,112.1v46.06c0,5.12,62.63,5.12,62.63,0v-46.06h-62.63Zm34.48,24.45v13.07c0,1.75-1.42,3.17-3.17,3.17s-3.17-1.42-3.17-3.17v-13.07c-2.69-1.21-4.56-3.91-4.56-7.05,0-4.27,3.46-7.73,7.73-7.73s7.73,3.46,7.73,7.73c0,3.14-1.87,5.84-4.56,7.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M601.46,108.82h-6.34v-3.1c0-10.75-8.74-19.49-19.49-19.49s-19.49,8.74-19.49,19.49v3.1h-6.34v-3.1c0-14.24,11.59-25.83,25.83-25.83s25.82,11.59,25.82,25.83v3.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M228.32,218.91c-4.09,4.61-5.86,10.32-5.54,15.88,.1,1.72,1.91,2.79,3.48,2.08,1.14-.51,2.3-.95,3.48-1.34,8.51-2.76,16.01-7.97,21.24-15.23l4.31-5.98c-8.87-4.93-20.22-3.01-26.97,4.59Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M343,224.66h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M343,224.66h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M551.32,225.59v0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M551.32,225.59v0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M447.55,175.7c-23.06,24.7-59.86,44.95-99.23,53.57-.01,2.63-.08,17.2-.38,84.36-.4,89.59,84.86,133.36,98.1,140.08,12.83-5.9,99.16-49.61,99.56-139.2,.3-67.16,.37-81.73,.38-84.36-39.3-8.98-75.58-29.55-98.42-54.46Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M447.34,185.42c-23.77,21.81-56.71,38.95-92.92,48.29l-.36,79.91c-.16,36.56,14.36,69.64,43.17,98.31,18.93,18.84,38.83,30.53,48.93,35.78,.43-.22,.91-.47,1.38-.71V185.61c-.07-.06-.14-.12-.21-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M447.55,185.61V447c10.5-5.46,29.59-16.76,47.87-34.63,29.07-28.42,43.89-61.36,44.05-97.92l.36-79.91c-36.03-9.64-68.72-27-92.28-48.93Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M520.11,265.7c-27.57,4.25-65.12,29.4-88.8,59.64-3.32-14.26-18.24-27.27-26.04-30.12l-23.64,23.76c14.76,6.65,30.89,25.5,33.03,44.79l23.62,3.66c9.96-19.67,35.67-66.71,86.83-92.01-.99-3.85-4.6-9.18-4.99-9.72Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M360.15,150.35c-.41-3.54-.61-7.2-.51-10.94,.08-2.9,.34-5.83,.82-8.76-4.09-.15-8.33-.24-12.68-.24s-9,.09-13.27,.26c.47,2.93,.74,5.85,.81,8.74,.1,3.72-.11,7.38-.52,10.91-2.17,18.89-10.19,33.97-10.19,33.97l22.86,9.7,22.86-9.67s-8.02-15.08-10.19-33.98Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "p"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a`",
    x: 347.45,
    y: 107.1,
    width: 32.16,
    height: 109.45
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "aq",
    cx: 341.31,
    cy: 185.75,
    r: 1.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "aq",
    cx: 332.07,
    cy: 182.27,
    r: 1.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "aq",
    cx: 353.68,
    cy: 185.75,
    r: 1.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M362.92,183.97c.94,0,1.71-.76,1.71-1.71s-.76-1.71-1.71-1.71-1.71,.76-1.71,1.71,.76,1.71,1.71,1.71Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M243.56,115.39c0-56.35,67.71-103.06,104.07-104.31,31.33-1.08,102.77,46.27,102.77,102.62"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ak"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "at",
    x: 210.73,
    y: -14.45,
    width: 120.29,
    height: 134.33
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "q",
    cx: 255.73,
    cy: 123.33,
    rx: 2.99,
    ry: 2.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "q",
    cx: 255.73,
    cy: 136.14,
    rx: 2.99,
    ry: 2.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "ag",
    points: "359.66 105.62 334.34 105.62 334.34 9.29 346.77 0 359.66 9.29 359.66 105.62"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ad"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a`",
    x: 347.32,
    y: -7.22,
    width: 23.36,
    height: 126.44
  }))), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M450.47,145.5H243.53v-34.55s48.37-14.49,103.89-13.59c71.92,1.16,103.05,13.59,103.05,13.59v34.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M340.8,73.42c-.92,0-1.67-1.1-1.67-2.45s.75-2.45,1.67-2.45,1.67,1.1,1.67,2.45-.75,2.45-1.67,2.45Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "aq",
    cx: 340.8,
    cy: 54.33,
    rx: 1.67,
    ry: 2.45
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "aq",
    cx: 340.8,
    cy: 37.69,
    rx: 1.67,
    ry: 2.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M340.8,23.5c-.92,0-1.67-1.1-1.67-2.45s.75-2.45,1.67-2.45,1.67,1.1,1.67,2.45-.75,2.45-1.67,2.45Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M353.47,73.42c-.92,0-1.67-1.1-1.67-2.45s.75-2.45,1.67-2.45,1.67,1.1,1.67,2.45-.75,2.45-1.67,2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M353.47,56.78c-.92,0-1.67-1.1-1.67-2.45s.75-2.45,1.67-2.45,1.67,1.1,1.67,2.45-.75,2.45-1.67,2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M353.47,40.14c-.92,0-1.67-1.1-1.67-2.45s.75-2.45,1.67-2.45,1.67,1.1,1.67,2.45-.75,2.45-1.67,2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M353.47,23.5c-.92,0-1.67-1.1-1.67-2.45s.75-2.45,1.67-2.45,1.67,1.1,1.67,2.45-.75,2.45-1.67,2.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M444.32,120.77c-1.65,0-2.99-1.24-2.99-2.76s1.34-2.76,2.99-2.76,2.99,1.24,2.99,2.76-1.34,2.76-2.99,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M444.32,133.58c-1.65,0-2.99-1.24-2.99-2.76s1.34-2.76,2.99-2.76,2.99,1.24,2.99,2.76-1.34,2.76-2.99,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M251.26,120.77c-1.65,0-2.99-1.24-2.99-2.76s1.34-2.76,2.99-2.76,2.99,1.24,2.99,2.76-1.34,2.76-2.99,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M251.26,133.58c-1.65,0-2.99-1.24-2.99-2.76s1.34-2.76,2.99-2.76,2.99,1.24,2.99,2.76-1.34,2.76-2.99,2.76Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "t"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M311.88,81.1c0,1.61-1.36,2.91-3.04,2.91h-31.57c-1.68,0-3.04-1.3-3.04-2.91h0c0-1.61,1.36-2.91,3.04-2.91h31.57c1.68,0,3.04,1.3,3.04,2.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M311.88,67.13c0,1.33-1.12,2.41-2.51,2.41h-26.1c-1.39,0-2.51-1.08-2.51-2.41h0c0-1.33,1.12-2.41,2.51-2.41h26.1c1.39,0,2.51,1.08,2.51,2.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M311.88,54.32c0,1.09-.92,1.97-2.05,1.97h-21.34c-1.13,0-2.05-.88-2.05-1.97h0c0-1.09,.92-1.97,2.05-1.97h21.34c1.13,0,2.05,.88,2.05,1.97h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M384.01,81.1c0,1.61,1.36,2.91,3.04,2.91h31.57c1.68,0,3.04-1.3,3.04-2.91h0c0-1.61-1.36-2.91-3.04-2.91h-31.57c-1.68,0-3.04,1.3-3.04,2.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M384.01,67.13c0,1.33,1.12,2.41,2.51,2.41h26.1c1.39,0,2.51-1.08,2.51-2.41h0c0-1.33-1.12-2.41-2.51-2.41h-26.1c-1.39,0-2.51,1.08-2.51,2.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M384.01,54.32c0,1.09,.92,1.97,2.05,1.97h21.34c1.13,0,2.05-.88,2.05-1.97h0c0-1.09-.92-1.97-2.05-1.97h-21.34c-1.13,0-2.05,.88-2.05,1.97h0Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToCheckout);
export default __webpack_public_path__ + "static/media/ToCheckout.48366113c0e580ff2356e86535dd317e.svg";
export { ForwardRef as ReactComponent };